import React from 'react';
import loadable from '@loadable/component';
import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { propTypes } from '../../util/types';
import FormspreeSection from '../PageBuilder/SectionBuilder/FormspreeSection/FormspreeSection';

import FallbackPage from '../LandingPage/FallbackPage';

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

const ASSET_NAME = 'contact_us_page';

// Create a default page structure
const defaultPageData = {
  sections: [
    {
      sectionId: "contact-form",
      sectionType: "formspree-section",
      sectionName: "Contact Form"
    }
  ]
};

export const ContactUsPageComponent = props => {
  const { pageAssetsData, inProgress, error } = props;

  // Define section overrides to register the custom component
  const sectionOverrides = {
    'formspree-section': { component: FormspreeSection },
  };

  // Merge console data with our default data
  const mergedPageData = {
    ...pageAssetsData?.contactUsPage?.data,
    sections: [
      ...(pageAssetsData?.contactUsPage?.data?.sections || []),
      ...defaultPageData.sections
    ]
  };

  return (
    <PageBuilder
      pageAssetsData={mergedPageData}
      inProgress={inProgress}
      error={error}
      options={{ sectionComponents: sectionOverrides }}
      fallbackPage={<FallbackPage error={error} />}
    />
  );
};

ContactUsPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
  error: propTypes.error,
};

const mapStateToProps = state => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  return { pageAssetsData, inProgress, error };
};

const ContactUsPage = compose(
  connect(mapStateToProps)
)(ContactUsPageComponent);

export default ContactUsPage; 